export default __webpack_public_path__ + "static/testimonials5-0d1e5f83cb51345262be4b97a12bb9f4.jpg";